"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_components_1 = require("styled-components");
const oxygen_config_1 = require("@8x8/oxygen-config");
const styled_1 = require("../styled");
const StaticTooltip = ({ children, forwardedRef, renderArrow, testId, theme, ...restProps }) => (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
    react_1.default.createElement(styled_1.TooltipWrapper, { ref: forwardedRef, ...restProps, ...(0, oxygen_config_1.getTestAttributes)(testId) },
        react_1.default.createElement(styled_1.TooltipContent, null, children),
        renderArrow && renderArrow())));
StaticTooltip.propTypes = {
    children: prop_types_1.default.node.isRequired,
    testId: prop_types_1.default.string,
    renderArrow: prop_types_1.default.func,
};
StaticTooltip.defaultProps = {
    testId: 'STATIC_TOOLTIP',
    renderArrow: undefined,
};
exports.default = (0, oxygen_config_1.withTheme)(StaticTooltip, 'staticTooltip');
